import styled from "styled-components";

export const CMCloseButton = styled.div((props) => ({
  textAlign: "right",
  position: "absolute",
  right: 32,
  top: 28,
  cursor: "pointer",
}));

export const CMwizardOrder = {
  height: 760,
};
export const CMwizardIssuer = {
  height: 450,
  width: 673,
};
export const OrderPrice = {
  display: "flex",
  width: "100%",
  maxWidth: "98%",
};
export const CMTitleStyle = {
  fontWeight: 500,
  top: "20%",
};
export const CMwizardConfirmOrder = {
  //width: 673,
  height: 780,
};
export const CMBackArrow = styled.div((props) => ({
  position: "absolute",
  left: 14,
  top: 15,
  cursor: "pointer",
  [`@media ${props.theme.breakpoints.xss}`]: {
    position: "absolute",
    left: "6%",
    top: "2%",
    cursor: "pointer",
  },
}));
